import React from 'react';
import MobileStepper from '@material-ui/core/MobileStepper';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import EnvironmentStore from 'lib/stores/environmentStore';
import ConfigStore from 'lib/stores/configStore';
import StepStore from 'lib/stores/stepStore';

import useWizardStepStyles from './useWizardStepStyles';
import useWizardStepCounterStyles from './useWizardStepCounterStyles';

const WizardStepper = () => {
  const { feature_wizard_stepper = 'true' } = EnvironmentStore.useState(state => state);
  const step = StepStore.useState(s => s.index);
  const stepProps = ConfigStore.useState(s => s.stepProps);
  const stepperLength = ConfigStore.useState(s => s.stepperLength);
  const stepperClasses = useWizardStepStyles();
  const stepCounterClasses = useWizardStepCounterStyles();

  const currentStepProps = stepProps[step];
  const { stepperHidden = false } = currentStepProps;

  const smallScreen = useMediaQuery('(max-width:768px)');

  if (stepperHidden) return <></>;

  if (smallScreen) {
    return (
      <div className={stepCounterClasses.counter}>
        Page
        {' '}
        {step + 1}
        {' '}
        of
        {' '}
        {stepperLength}
      </div>
    );
  }

  if (feature_wizard_stepper === 'false') return <></>;

  return (
    <div className={stepperClasses.stepperContainer}>
      <MobileStepper
        variant="dots"
        steps={stepperLength}
        activeStep={step}
        position="static"
        classes={{
          root: stepperClasses.root,
          dotActive: stepperClasses.active,
        }}
      />
    </div>
  );
};

export default WizardStepper;
